export default __webpack_public_path__ + "static/media/jd-power-awards-2021.4861284f.png";